export default __webpack_public_path__ + "static/logo-ceoh-foot-8ff30cd9a5b6840e4894e7784f09dfed.png";